module.exports = __webpack_public_path__ + "img/28.f2e97e79.jpg";